import React from "react";
import img from "../assets/images/sidom/fotos/pinSIDOM.png";

export default function AboutStory() {
  return (
    <section className="relative mt-[70px] md:mt-[100px] lg:mt-[100px] mb-[70px] md:mb-[100px] lg:mb-[100px]">
      <div className=" px-2 md:px-0 lg:px-0 mx-auto">
        <div className="flex flex-col container md:flex-row items-start gap-9 md:gap-20 lg:gap-20 text-xs sm:text-sm md:text-base lg:text-xl">
          <div className="w-full md:w-[50%] flex flex-col justify-start md:items-end md:justify-start">
            <img
              src={img}
              className="rounded-lg h-full  mb-10 w-20 md:w-[65px] md:mb-0  relative"
              alt=""
            />
            <br />
            <p className=" leading-6 lg:leading-7   text-ellipsis text-left md:text-right font-medium">
              <strong className="text-sidom-orange">SIDOM </strong> surge de una
              historia de sueños audaces, perseverancia y una visión global.
              Fundada por tres emprendedores con una pasión inquebrantable por
              revolucionar el comercio exterior, nuestra empresa nació en un
              modesto galpón en Argentina, impulsada por un propósito claro:
              ofrecer una solución integral e innovadora para la gestión de la
              logística y el comercio internacional.
            </p>
          </div>
          <div className=" w-full md:w-[50%]">
            <div className="">
              <p className="text-sidom-dark leading-6 lg:leading-7   text-left  dark:text-sidom-light mx-auto">
                Desde el comienzo, sabíamos que el éxito en el comercio global
                requiere algo más que tecnología avanzada. Requiere entender y
                abrazar las complejidades únicas de cada cliente. Fue nuestra
                obsesión por el cliente lo que nos llevó a desarrollar un
                enfoque personalizado, mucho antes de que este concepto se
                convirtiera en una tendencia. Cada desafío que enfrentaron
                nuestros clientes se convirtió en una oportunidad para innovar y
                automatizar, creando un producto que no solo se adapta, sino que
                se anticipa a las necesidades cambiantes del mercado.
                <br />
                <br />
                Hoy, después de
                <strong> 20 años </strong>de liderazgo y presencia en
                <strong> 14 países,</strong>
                <strong className="text-sidom-orange"> SIDOM</strong> no sólo ha
                cumplido su promesa, sino que la ha elevado a nuevas alturas.
                Nuestra suite de soluciones es única por su capacidad para
                integrarse perfectamente con el ecosistema del comercio global
                de todo el mundo y adaptarse a los procesos específicos de cada
                compañía. Este enfoque flexible y nuestra capacidad de
                personalización nos han convertido en el aliado preferido para
                las principales empresas globales, así como para marcas
                regionales en expansión.
                <br />
                <br /> El mundo del comercio internacional está en constante
                evolución, y en 
                <strong className="text-sidom-orange"> SIDOM</strong> , estamos
                comprometidos a ser el socio que guía a las empresas hacia el
                futuro. Nuestra plataforma escalable nos permite crecer junto a
                nuestros clientes. Somos el puente entre la ambición regional y
                el éxito global.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
